import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelTypeEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelTypeEntity
